import { AbstractService } from '@uniqoders/sdk';

export default class StoryService extends AbstractService {
  /**
   * Retrieve paginated CMS stories for an agency
   */
  public listCmsStories(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/stories', { agency }),
      params,
      options: {
        paginate: true,
      },
    });
  }

  /**
   * Retrieve a single CMS story
   */
  public getCmsStory(agency: string, cmsStoryId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/stories/{cmsStoryId}', { agency, cmsStoryId }),
      params,
      headers,
    });
  }

  /**
   * Create a new CMS story
   */
  public createCmsStory(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/stories', { agency }),
      data,
    });
  }

  /**
   * Update an existing CMS story
   */
  public updateCmsStory(agency: string, cmsStoryId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/stories/{cmsStoryId}', { agency, cmsStoryId }),
      data,
    });
  }

  /**
   * Delete a CMS story
   */
  public deleteCmsStory(agency: string, cmsStoryId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/stories/{cmsStoryId}', { agency, cmsStoryId }),
    });
  }

  /**
   * Publish or unpublish a CMS story
   */
  public publishCmsStory(
    agency: string,
    cmsStoryId: number,
    data: { is_public: boolean; published_at?: string | null },
  ): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/stories/{cmsStoryId}/publish', { agency, cmsStoryId }),
      data,
    });
  }

  /**
   * Upload a featured image via multipart form-data
   */
  public uploadFeaturedImage(agency: string, cmsStoryId: number, data: FormData): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/stories/{cmsStoryId}/featured', { agency, cmsStoryId }),
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  /**
   * Upload gallery images via multipart form-data
   */
  public uploadGalleryImages(agency: string, cmsStoryId: number, data: FormData): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/stories/{cmsStoryId}/gallery', { agency, cmsStoryId }),
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

